import type { Thread } from '../thread/thread';
import type { AttachmentInput } from '../thread/attachment-utils';

export const collectAttachmentsFromUserTurn = (
  thread: Thread,
  messageIndex: number,
): AttachmentInput[] => {
  const attachments: AttachmentInput[] = [];

  // Look backward to find images/files from the same user turn
  for (let i = messageIndex - 1; i >= 0; i--) {
    const historyItem = thread.history[i];
    if (historyItem.role !== 'user') break;

    if (historyItem.type === 'message') {
      if (historyItem.content.type === 'image') {
        attachments.unshift({
          data: historyItem.content.url,
          mimeType: 'image/png',
          name: historyItem.content.name || 'image',
        });
      } else if (historyItem.content.type === 'file') {
        attachments.unshift({
          data: historyItem.content.url,
          mimeType: historyItem.content.mimeType,
          name: historyItem.content.name || 'file',
        });
      }
    }
  }

  return attachments;
};
